"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_warning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("title", null, "warning-mid"), /*#__PURE__*/React.createElement("g", {
    id: "d6b47a1d-4591-48cb-9324-ef02085259a7",
    "data-name": "ICON"
  }, /*#__PURE__*/React.createElement("g", {
    id: "f29f07d3-4dbc-4942-a202-dd51ab985b76",
    "data-name": "Business_ic_mid"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d1be9603-798e-46ae-b78b-45f5745ed395",
    "data-name": "<Gruppe>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "fb04ec9f-9ed5-4de4-a879-a50ec6975f38",
    "data-name": "<Pfad>",
    d: "M170.34,137.49c8.58,15.21,1.56,28.51-15.6,28.51H37.27c-17.16,0-24.19-13.3-15.6-28.51L80.4,29.36c8.55-14.75,22.53-15.53,31.21,0Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    id: "01102ec2-bc44-4a2c-bf9c-c758e144e4d9",
    "data-name": "<Pfad>",
    x1: 96,
    y1: 58,
    x2: 96,
    y2: 118,
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 136,
    r: 2,
    fill: "none",
    stroke: "#e60000",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }))));
}

var _default = ic_warning;
exports.default = _default;